(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MapaimagemVisualizarController', MapaimagemVisualizarController);

    MapaimagemVisualizarController.$inject = ['DataUtils', 'Mapaimagem', 'ParseLinks', 'AlertService', 'paginationConstants', '$stateParams'];

    function MapaimagemVisualizarController(DataUtils, Mapaimagem, ParseLinks, AlertService, paginationConstants, $stateParams) {
        var vm = this;
        vm.carregando = true;
        vm.sucesso = sucesso;
        vm.nomemapa = null;

        vm.idmapa = $stateParams.id;


        function sucesso(data){
            vm.nomemapa = data[0].nomemapa;
            vm.fileURL = 'data:' + data[0].imagempequenaContentType +';base64,' + data[0].imagempequena;
            vm.carregando = false;
        }

        Mapaimagem.queryImagemPequena({mapaid: vm.idmapa}, vm.sucesso);

    
    }
})();
